<div class="container">
    <div id="search-cards">
        <input 
            type="text" 
            [(ngModel)]="name" 
            placeholder="Digite o nome da carta" 
            (input)="Search()"
        />
    </div>
    
    <div id="cards" *ngFor="let card of cards">
        <a routerLink="/cards/{{card.id}}">
            <figure class="card card--normal">
                <div class="card__image-container">
                    <img src={{card.imageUrl}} alt="Imagem Pokemon">
                </div>

                <figcaption class="card__caption">
                    <h1 class="card__name">{{card.name}}</h1>

                    <h3 class="card__type">
                        {{card.rarity}}
                    </h3>

                    <table class="card__stats">
                        <tbody>
                            <tr>
                                <th>ID</th>
                                <td>{{card.id}}</td>
                            </tr>
                            <tr>
                                <th>HP</th>
                                <td>{{card.hp}}</td>
                            </tr>

                            <tr>
                                <th>Tipo</th>
                                <td>{{card.types}}</td>
                            </tr>
                        </tbody>
                    </table>
                </figcaption>
            </figure>
        </a>
    </div>
</div>